<div class="container_dati_generali">
  <form [formGroup]="formGroup" *ngIf="formGroup">
    <div class="row">
      <div comboModInput class="col-sm-3"
          [labelInput]="'Materia'"
          [mandatory]="true"
          [control]="formGroup.controls['materia']"
          [labelOption]="'label'"
          [objectReference]="formGroup.get('materia').value"
          [noOrder]="true"
          (onReturn)="formGroup.get('materia').setValue($event)"
          [optionsCombo]="(materieOptions$ | async) || [] ">
      </div>
      <div comboModInput class="col-sm-3"
          [labelInput]="'Oggetto'"
          [mandatory]="true"
          [control]="formGroup.controls['oggetto']"
          [labelOption]="'label'"
          [objectReference]="formGroup.get('oggetto').value"
          [noOrder]="true"
          (onReturn)="formGroup.get('oggetto').setValue($event)"
          [optionsCombo]="(oggettiOptions$ | async) || []">
      </div>
      <div comboModInput class="col-sm-3"
          [labelInput]="'Argomento'"
          [control]="formGroup.controls['argomento']"
          [labelOption]="'label'"
          [objectReference]="formGroup.get('argomento').value"
          [noOrder]="true"
          (onReturn)="formGroup.get('argomento').setValue($event)"
          [optionsCombo]="(argomentiOptions$ | async) || []">
      </div>
      <div checkBoxRadio class="col-sm-3"
          [labelInput]="'Primaria'"
          idInput="isPrincipale"
          [objectReference]="formGroup.get('isPrincipale').value"
          [submitPending]="!hasPrincipale"
          [control]="formGroup.controls['isPrincipale']"
          (onReturn)="formGroup.get('isPrincipale').setValue($event)"
      >
      </div>
    </div>
    <div class="row">
      <p class="col-sm-2 col-xs-offset-6 col-sm-offset-10">
        <button (click)="addClassificazione();"
                [disabled]="!formGroup.valid"
                type="button" class="btn btn-primary btn-block">Aggiungi
        </button>
      </p>
    </div>
  </form>
</div>
